import { Constructor } from '../../Utility/Mixin';
import { BaseError } from 'make-error';

/**
 * Thrown when caching a `reachasset://` image fails.
 */
export class ReachAssetRetrievalError extends BaseError {
    detail: {
        assetUri?: string;
        event?: string | Event;
    };

    constructor(message = 'ReachAssetRetrievalError', assetUri?: string, event?: string | Event) {
        if (assetUri) {
            message += ` (${assetUri})`;
        }
        super(message);

        this.detail = {
            assetUri,
            event,
        };
    }
}

/**
 *
 * @param Base Class to apply mixin to
 */
// This 'eslint disable' is allowed on mixins as one cannot describe the return
// type since the class is being defined in the mixin.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function ReachAssetMixin<TBase extends Constructor>(Base: TBase) {
    return class ReachAssetMixin extends Base {
        /**
         * Get `reachasset://` URL for cached image asset.
         *
         * The REACH Signage Software will automatically download assets not
         * already cached.
         * @throws {@link ReachAssetError}
         */
        getReachImageAssetUrl(url: string): Promise<string> {
            return new Promise((resolve, reject) => {
                // Get cached asset via `reachasset://`

                // `reachasset://` requires an absolute url
                const anchorElement = document.createElement('a');
                anchorElement.href = url; // put potentially relative url into anchor element(<a>)
                const absoluteURL = anchorElement.href; // retrieve relative url from anchor element(<a>)

                // The REACH Signage Software will automatically download assets
                // not already cached
                const signageAssetUrl = 'reachasset://' + btoa('image://' + absoluteURL);

                // fetch asset via `<img>` element to see errors (http://stackoverflow.com/a/5058336)
                const img = new Image();
                img.onload = function (): void {
                    // image is loaded;
                    resolve(signageAssetUrl);
                };
                img.onerror = function (event: string | Event): void {
                    // image is not loaded
                    reject(
                        new ReachAssetRetrievalError(
                            'Failed to retrieve REACH Asset.',
                            absoluteURL,
                            event
                        )
                    );
                };
                img.src = signageAssetUrl;
            });
        }
    };
}
